function bytesToHex(buf) {
    const b = new Uint8Array(buf);
    return [...b].map(x => x.toString(16).padStart(2, "0")).join("");
}
function hexToBytes(hex) {
    const out = new Uint8Array(hex.length / 2);
    for (let i = 0; i < out.length; i++) out[i] = parseInt(hex.substr(i * 2, 2), 16);
    return out;
}
function base64ToBytes(b64) {
    const bin = atob(b64);
    const out = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out;
}

/**
 * Firma HMAC-SHA256 e restituisce hex.
 * La secret può essere HEX (lunghezza pari, solo [0-9a-f]) oppure Base64.
 */
export async function hmacHex(bodyString, secret) {
    const isHex = /^[0-9a-f]+$/i.test(secret) && secret.length % 2 === 0;
    const keyBytes = isHex ? hexToBytes(secret) : base64ToBytes(secret);
    const cryptoKey = await crypto.subtle.importKey(
        "raw",
        keyBytes,
        { name: "HMAC", hash: { name: "SHA-256" } },
        false,
        ["sign"]
    );
    const sig = await crypto.subtle.sign("HMAC", cryptoKey, new TextEncoder().encode(bodyString));
    return bytesToHex(sig);
}
